var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColour = function SvgColour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#colour_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.905 8.572a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428M8.048 17.143a.857.857 0 1 0 0-1.714.857.857 0 0 0 0 1.714M8.047 11.143a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.653 21.052a1.71 1.71 0 0 0-1.114-1.509 3.429 3.429 0 0 1 1.08-6.686h3.205a3.43 3.43 0 0 0 3.24-4.577 11.142 11.142 0 1 0-10.508 14.863 10.8 10.8 0 0 0 2.983-.411 1.54 1.54 0 0 0 1.114-1.68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "colour_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333 0h24v24h-24z"
  })))));
};
export default SvgColour;